<domain-list>

  <div class="url_container">
    <div class="radio_wrap">
      <input class="radio-input" type="radio" name="direction" value="include" id="include" checked onchange="{ e => {props.onChangeDomainRestrictedDirection(e);onSomethingChange(e);} }">
      <label class="radio_label" for="include">限定する</label>
      <input class="radio-input" type="radio" name="direction" value="exclude" id="exclude" onchange="{ e => {props.onChangeDomainRestrictedDirection(e);onSomethingChange(e);} }">
      <label class="radio_label" for="exclude">除外する</label>
    </div>
    <div
      class="url_wrap domain-url active"
      each="{ (url, i) in props.domains }"
    >
      <input
        type="text"
        class="url-input url-acquired"
        value="{ url }"
        readonly
      />
      <button
        class="button button-clear"
        type="button"
        value="クリア"
        onclick="{ e => {props.onDomainRemove(e, i);onSomethingChange(e);} }"
      >
        クリア
      </button>
    </div>
    <div class="url_wrap domain-url active" if={!state.limited}>
      <input
        type="text"
        name="append-domain"
        class="url-input"
        size="67"
        maxlength=""
      />
      <button
        class="button button-tertiary button-add"
        type="button"
        value="追加する"
        onclick="{ e => {props.onDomainAppend(e);onSomethingChange(e);} }"
      >
        追加する
      </button>
      <div
        class="err-msg"
        style="display: block;"
        if="{ props.domainError }"
      >
        { props.domainError }
      </div>
    </div>
    <!--/.url_wrap-->
  </div>
  <!--/.url_container-->
  <script>
    export default {
      state: {
        direction: 'include',
        limited: false
      },
      onMounted() {
        const inc = this.$('#include').checked;
        this.state.direction = inc ? 'include' : 'exclude';
        this.state.limited = inc && this.props.domains.length > 0;
      },
      onSomethingChange(e) {
        const inc = this.$('#include').checked;
        this.state.direction = inc ? 'include' : 'exclude';
        //「限定」で1つ以上という条件になった瞬間に追加制限＆ドメイン数を1に削る
        this.state.limited = inc && this.props.domains.length > 0;
        if (this.state.limited) {
          for (let i=this.props.domains.length-1; i>0; i--) {
            this.props.onDomainRemove(e, i)
          }
        }
        this.update();
      }
    }
    

  </script>
</domain-list>